export default __webpack_public_path__ + "static/media/noimage-placeholder.c5b0300a.svg";